export class SelectOption {
  value: string;
  text: string;
}
